const themeEnum = {
    Light: 'Light',
    Dark: 'Dark'
};
const roleEnum = {
    admin: 'ADMIN',
    user: 'USER'
};
const actionsEnum = {
    Edit: 'Edit',
    Delete: 'Delete',
    Configure: 'Configure',
    Rename: 'Rename',
    Remove: 'Remove'
};
const adminEnum = {
    superAdmin: 'Super Admin'
};
const wareHouse = [{
    Ware: 'Dubai',
},
{
    Ware: 'Pakistan'
}
];
const screenEnum = {
    user: 'user',
    po: 'po',
    product: 'product',
    inventory: 'inventory',
    tasks: 'task',
    so: 'so',
    internal_transfer: 'internal_transfer',
    return: 'return',
    rough_listing: 'rough-listing'
};
const taskPriorityEnum = {
    LOW: 'LOW',
    MIDDLE: 'MEDIUM',
    HIGH: 'HIGH'
};
const screenActionEnum = {
    update: 'update',
    create: 'create',
    delete: 'delete'
};
const statusEnum = {
    inprogress: 'In Progress',
    inActive: 'In Active',
    pending: 'Pending',
    pipeline: 'in Pipeline',
    inBlocked: 'in Blocked',
    inCompleted: 'Completed',
    overDue: 'overdue',
    noticePeriod: 'Notice Period',
    probation: 'Probation',
    permanent: 'Permanent'
};
const dateRangesEnum = {
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    last7Days: 'Last 7 Days',
    lastMonth: 'Last Month',
    thisQuarter: 'This Quarter',
    lastQuarter: 'Last Quarter',
    thisYear: 'This Year',
    lastYear: 'Last Year',
    customDateRange: 'Custom Date'
};
const taskEnum = {
    COMPLETED: 'COMPLETED',
    INPROGESS: 'IN PROGRESS',
    PENDING: 'PENDING',
    BLOCK: 'BLOCK'
};
const task_assign = {
    ASSIGN: 'ASSIGN',
    UNASSIGN: 'UNASSIGN'
};
export { themeEnum, wareHouse, actionsEnum, statusEnum, dateRangesEnum, screenActionEnum, roleEnum, adminEnum, screenEnum, taskPriorityEnum, taskEnum, task_assign };
